module.exports = __webpack_public_path__ + "img/ic_sideways_plane.d82ddbb3.svg";